import React from 'react';
import { Card, List, Tooltip, Typography } from 'antd';
import { CheckSquareOutlined, DeleteOutlined } from '@ant-design/icons';
import Button from "@common/Button";

const { Title, Text } = Typography;

const ExitQuizCard = ({
    exitQuizQuestions,
    isEditMode,
    getResourceIcon,
    handleRemoveListItem
}) => {
    return (
        <div id="lesson-exit-quiz">
            <Title level={2}>Exit Quiz</Title>
            <Card size="small" icon={<CheckSquareOutlined />}>
                <List
                    dataSource={exitQuizQuestions || []}
                    renderItem={(resource, resourceIndex) => (
                        <List.Item
                            key={resource.documentId || resourceIndex}
                            actions={isEditMode ? [
                                <Tooltip title="Remove question">
                                    <Button
                                        type="text"
                                        danger
                                        shape="circle"
                                        icon={<DeleteOutlined />}
                                        onClick={() => handleRemoveListItem(
                                            'exitQuizQuestions',
                                            resourceIndex,
                                            resource.displayTitle || 'this question'
                                        )}
                                    />
                                </Tooltip>
                            ] : []}
                        >
                            <List.Item.Meta
                                avatar={getResourceIcon(resource.contentType)}
                                title={resource.displayTitle}
                                description={resource.contentSummary}
                            />
                        </List.Item>
                    )}
                />
                {(exitQuizQuestions == null || exitQuizQuestions.length === 0) && (
                    <Text type="secondary" italic>No exit quiz questions were generated for this lesson.</Text>
                )}
            </Card>
        </div>
    );
};

export default ExitQuizCard;
